import { CompleteProfileModal } from "./CompleteProfileModal";

export { DIALOG_ID } from "./CompleteProfileModal";
export default CompleteProfileModal;
